import React from "react";
import "./App.css";
import Login from "./components/Login";
import FormAddUser from "./components/FormAddUser";
import AdminUserList from "./components/AdminUserList";
import EditUserList from "./components/EditUserList";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  BrowserRouter,
  useNavigate,
} from "react-router-dom";
import Products from "./components/users/Products";
import ViewProject from "./components/users/ViewProject";
import UserLogin from "./components/users/UserLogin";
import Homepage from "./components/admin/Homepage";
import MainLayout from "./components/admin/MainLayout";
import Summary from "./components/users/Summary";
import UserLayout from "./components/users/UserLayout";
import UserHomepage from "./components/users/UserHomepage";
import UserProjects from "./components/users/UserProjects";
import ViewProjects from "./components/users/ViewProjects";
import AdminForgotPassword from "./components/users/UserForgotPassword";
import CreatePassword from "./components/CreatePassword";
// import UpdatePassword from './components/users/UpdatePassword';
import ResetPassword from "./components/users/ResetPassword";
import ChangePassword from "./components/users/ChangePassword";
import ProtectedRoute from "./components/routes/ProtectedRoute";
import UserHelpDesk from "./components/users/UserHelpDesk";
import HelpDeskList from "./components/admin/HelpDeskList";
import AdminLogin from "./components/routes/AdminLogin";
import Log from "./components/admin/Log";
import LogDetails from "./components/admin/LogDetails";
import ViewClient from "./components/users/ViewClient";
import AddClient from "./components/users/AddClient";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Projects from "./components/admin/Projects";
import ViewProjectDownload from "./components/users/ViewProjectDownload";
import UserDashboard from "./components/users/UserDashboard";
import AdminDashboard from "./components/admin/AdminDashboard";
import AdminClientList from "./components/AdminClientList";
import AdminProduct from "./components/admin/AdminProduct";
import AdminViewProject from "./components/admin/AdminViewProject";
import AdminCoverImages from "./components/admin/AdminCoverImages";
import AdminAiManagement from "./components/admin/AdminAiManagement";
import Draft from "./components/users/Draft";
import Manual from "./components/users/Manual";
import PasswordResetPopup from "./components/utils/PasswordResetPopup";
import { useEffect } from "react";
import axios from "axios";
import Apiurl from "./Helpers/apiUrl";
import TablePreview from "./components/Additional/TablePreview";
import QuoteByUserId from "./components/Additional/admin_dash/QuoteByUserId";
import OpenSkuUses from "./components/Additional/admin_dash/OpenSkuUses";
import CollectionSku from "./components/Additional/admin_dash/CollectionSku";
import DataTransfer from "./components/admin/transfer/DataTransfer";
import History from "./components/admin/transfer/History";
import UserEngagement from "./components/admin/UserEngagement";
import Swal from "sweetalert2";
import QuotationReport from "./components/admin/QuotationReport";
import Inventory from "./components/admin/Inventory";
import MailLog from "./components/admin/MailLog";
import AuthCheck from "./components/routes/AuthCheck";
import { DrawerProvider } from "./DrawerContext";
import Dashboard from "./components/admin/Dashboard";
import ProductLog from "./components/admin/ProductLog";
import Customer from "./components/admin/Customer";
import CreateQuote from "./components/users/CreateQuote";
import PdfSettings from "./components/users/PdfSettings";
import { PdfProvider } from "./components/context/pdfContext";
import PdfDownloadBg from "./components/users/PdfDownloadBg";
import SmartSuggestion from "./components/admin/SmartSuggestion";
import UserProducts from "./components/users/UserProducts";
import UserInventory from "./components/users/UserInventory";
import DeviceLog from "./components/admin/DeviceLog";
import AdminDash from "./components/admin/admin_dashboard/AdminDash";
import AdminDynamicDashboard from "./components/admin/AdminDynamicDashboard";
import Settings from "./components/users/Settings";
import { fetchLiveExchangeRates } from "./Helpers/currencyHelper";
import Currency from "./components/admin/Currency";
import CreateQuote2 from "./components/users/CreateQuote2";

const AdminMap = React.lazy(() => import("./components/admin/AdminMap"));

function App() {

  useEffect(() => {
    let timeoutId;

    const pollProfile = async () => {
      await profile();
      timeoutId = setTimeout(pollProfile, 10000);
    };

    pollProfile();
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    fetchLiveExchangeRates();
  }, []);

  const profile = async () => {
    if (document.visibilityState !== 'visible') return;
    try {
      const user = localStorage.getItem("u_token");
      if (!user) return;

      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user,
      };

      const response = await axios.get(`${Apiurl}profile`, { headers });
      if (response.status === 200) {
        localStorage.setItem("_code_sign", response?.data?.data?.emp_code);
      }

    } catch (error) {
      const isUnauthorized = error.response && error.response.status === 401;
      const isNetworkError = !error.response;

      if (isUnauthorized) {
        localStorage.removeItem("u_token");
        localStorage.removeItem("role_code");

        const currentPath = window.location.pathname;
        const isExemptPath =
          currentPath === "/" ||
          currentPath === "/admin/login" ||
          currentPath.includes("password-reset") ||
          currentPath.includes("forgotPassword");

        if (!isExemptPath) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Session Expired! Login again to continue.",
          });
          setTimeout(() => {
            window.location.href = "/";
          }, 2000);
        }
      } else if (isNetworkError) {
        console.log('NTWRK', error)
        // Swal.fire({
        //   icon: "warning",
        //   title: "Connection Lost",
        //   text: "Your connection has been lost. Please connect to the internet to continue.",
        // });
      } else {
        console.error("Profile API Error:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "An unexpected error occurred. Please try again later.",
        });
      }
    }
  };

  return (
    <>

      <BrowserRouter>
        <PdfProvider>
          <DrawerProvider>
            <Routes>
              {/* admin Routes */}
              <Route path="/admin">
                <Route path="login" element={<AuthCheck><Login /></AuthCheck>} />
                {/* <Route path="login" element={<Login />}></Route> */}
                <Route
                  path="home"
                  element={
                    <AdminLogin>
                      <Homepage />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="projects"
                  element={
                    <AdminLogin>
                      <Projects />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="projects/report"
                  element={
                    <AdminLogin>
                      <QuotationReport />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="product-log"
                  element={
                    <AdminLogin>
                      <ProductLog />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="customer"
                  element={
                    <AdminLogin>
                      <Customer />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="preview"
                  element={
                    <AdminLogin>
                      <TablePreview />
                    </AdminLogin>
                  }
                ></Route>

                <Route
                  path="product"
                  element={
                    <AdminLogin>
                      <AdminProduct />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="inventory"
                  element={
                    <AdminLogin>
                      <Inventory />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="currency"
                  element={
                    <AdminLogin>
                      <Currency />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="addUser"
                  element={
                    <AdminLogin>
                      <FormAddUser />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="userlist"
                  element={
                    <AdminLogin>
                      <AdminUserList />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="clientlist"
                  element={
                    <AdminLogin>
                      <AdminClientList />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="edit/:id"
                  element={
                    <AdminLogin>
                      <EditUserList />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="viewProjects"
                  element={
                    <AdminLogin>
                      <AdminViewProject />
                    </AdminLogin>
                  }
                />
                <Route
                  path="help/desks"
                  element={
                    <AdminLogin>
                      <HelpDeskList />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="log"
                  element={
                    <AdminLogin>
                      <Log />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="smart-suggestions"
                  element={
                    <AdminLogin>
                      <SmartSuggestion />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="log/details"
                  element={
                    <AdminLogin>
                      <LogDetails />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="device/log"
                  element={
                    <AdminLogin>
                      <DeviceLog />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="transfer"
                  element={
                    <AdminLogin>
                      <DataTransfer />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="transfer/history"
                  element={
                    <AdminLogin>
                      <History />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="users-engagement"
                  element={
                    <AdminLogin>
                      <UserEngagement />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="mails"
                  element={
                    <AdminLogin>
                      <MailLog />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="ai-management"
                  element={
                    <AdminLogin>
                      <AdminAiManagement />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="map"
                  element={
                    <AdminLogin>
                      <React.Suspense fallback={<div>Loading map...</div>}>
                        <AdminMap />
                      </React.Suspense>
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="dashboard"
                  element={
                    <AdminLogin>
                      <AdminDashboard />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="dashboard2"
                  element={
                    <AdminLogin>
                      <AdminDash />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="dynamic-dashboard"
                  element={
                    <AdminLogin>
                      <AdminDynamicDashboard />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="dash"
                  element={
                    <AdminLogin>
                      <Dashboard />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="cover-images"
                  element={
                    <AdminLogin>
                      <AdminCoverImages />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="/admin/quotation-by-user"
                  element={
                    <AdminLogin>
                      <QuoteByUserId />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="/admin/collection-skus"
                  element={
                    <AdminLogin>
                      <CollectionSku />
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="/admin/sku-uses"
                  element={
                    <AdminLogin>
                      <OpenSkuUses />
                    </AdminLogin>
                  }
                ></Route>
              </Route>

              {/* user Routes */}
              {/* <Route path="/" element={<UserLogin />} /> */}
              <Route path="/" element={<AuthCheck><UserLogin /></AuthCheck>} />
              <Route
                path="forgotPassword"
                element={<AdminForgotPassword />}
              ></Route>
              <Route
                path="password-reset/:token"
                element={<ResetPassword />}
              ></Route>
              <Route path="*" element={<h2>no page found</h2>} />
              <Route
                path="/user"
                element={
                  <ProtectedRoute>
                    <UserLayout />
                  </ProtectedRoute>
                }
              >
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <UserHomepage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="change-password"
                  element={
                    <ProtectedRoute>
                      <ChangePassword />
                    </ProtectedRoute>
                  }
                ></Route>
                <Route
                  // path="projects/:projectId?"
                  path="projects/:cid?/:clientName?/:projectId?"
                  element={
                    <ProtectedRoute>
                      <UserProjects />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="create-quote/:cid?/:clientName?/:projectId?"
                  element={
                    <ProtectedRoute>
                      <CreateQuote />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="create-quote-fx/:cid?/:clientName?/:projectId?"
                  element={
                    <ProtectedRoute>
                      <CreateQuote2 />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="pdf-settings"
                  element={
                    <ProtectedRoute>
                      <PdfSettings />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="settings"
                  element={
                    <ProtectedRoute>
                      <Settings />
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="summary"
                  element={
                    <ProtectedRoute>
                      <Summary />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="products"
                  element={
                    <ProtectedRoute>
                      <UserProducts />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="inventory"
                  element={
                    <ProtectedRoute>
                      <UserInventory />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="project/download"
                  element={
                    <ProtectedRoute>
                      <ViewProjectDownload />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="viewProjects"
                  element={
                    <ProtectedRoute>
                      <ViewProjects />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="view"
                  element={
                    <ProtectedRoute>
                      <ViewProject />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="help-desk"
                  element={
                    <ProtectedRoute>
                      <UserHelpDesk />
                    </ProtectedRoute>
                  }
                ></Route>
                <Route path="products" element={<Products />}></Route>
                <Route
                  path="viewclient"
                  element={
                    <ProtectedRoute>
                      <ViewClient />
                    </ProtectedRoute>
                  }
                ></Route>
                <Route
                  path="add-client"
                  element={
                    <ProtectedRoute>
                      <AddClient />
                    </ProtectedRoute>
                  }
                ></Route>
                <Route
                  path="map"
                  element={
                    <AdminLogin>
                      <React.Suspense fallback={<div>Loading map...</div>}>
                        <AdminMap />
                      </React.Suspense>
                    </AdminLogin>
                  }
                ></Route>
                <Route
                  path="dashboard"
                  element={
                    <ProtectedRoute>
                      <UserDashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="draft"
                  element={
                    <ProtectedRoute>
                      <Draft />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="manual"
                  element={
                    <ProtectedRoute>
                      <Manual />
                    </ProtectedRoute>
                  }
                />
              </Route>
            </Routes>
          </DrawerProvider>
          <PdfDownloadBg />
        </PdfProvider>
      </BrowserRouter>
      <ToastContainer />
      <PasswordResetPopup />
    </>
  );
}

export default App;
